export enum OPTION {
  NEW_BID = "New Bid",
  UPDATE_BID = "Update Bid",
}

export enum BID_CREATE_STATUS {
  SUCCESS = "success",
  FAILED = "failed",
}

export enum BID_REQUEST_TYPE {
  Create = "Bid Request",
  Update = "Update Request",
}
